import { TableCell, Button, Collapse, TableRow } from "@material-ui/core";
import React from "react";
import { style } from "./style";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import moment from "moment";

import Loading from "../../loading";
import Snackbar from "../../snackbar";
import Detail from "./detail";
import Header from "../../../partials/header";
import TableFormat from "../../../partials/TableFormat";
import PriceFormat from "../../../partials/priceFormat";
import { rowsPerPage } from "../../../utils/setting";
const headCells = [
  {
    key: "createdAt",
    numeric: false,
    disablePadding: false,
    label: "payment_time"
  },
  {
    key: "oldBalance",
    numeric: false,
    disablePadding: false,
    numeric: true,
    label: "payment_old_balance"
  },
  {
    key: "newBalance",
    numeric: false,
    disablePadding: false,
    numeric: true,
    label: "payment_new_balance"
  },
  {
    key: "content",
    numeric: false,
    disablePadding: false,
    label: "payment_content"
  },
  {
    key: "creator",
    numeric: false,
    disablePadding: false,
    label: "payment_creator"
  }
  // { key: 'action', numeric: false, disablePadding: false, label: 'action' },
];
class Payment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      historyPayment: [],
      page: 0,
      collapse: [],
      rowsPerPage: rowsPerPage
    };
  }
  async componentDidMount() {
    this.getHistory({ limit: this.state.rowsPerPage, page: this.state.page });
  }
  getHistory = async payload => {
    let { adminService, serviceCode } = this.props;
    this.loading.startLoading();
    let check = await this.props.getHistory({
      ...payload,
      serviceCode: adminService.no
    });
    this.loading.stopLoading();
    if (check.code === 1) this.setState({ historyPayment: check.data.list });
  };
  changeFormat(datetime) {
    return moment(datetime).format("DD/MM/YYYY k:mm:ss");
  }
  handleOpenCollapes = id => {
    const { historyPayment, collapse } = this.state;
    for (let i = 0; i <= historyPayment.length; i++) {
      if (i === id) {
        collapse[i] = !collapse[i];
      } else collapse[i] = false;
    }
    this.setState(collapse);
  };
  renderCollapse = (row, index) => {
    const { classes } = this.props;
    const { historyPayment, collapse } = this.state;
    return (
      <TableRow className={classes.tableRowHeight} key={index}>
        <TableCell
          colSpan={9}
          padding={"none"}
          className={classes.tableCellInCollapes}
        >
          <Collapse in={collapse[index]} unmountOnExit>
            <Detail row={historyPayment[index]} />
          </Collapse>
        </TableCell>
      </TableRow>
    );
  };
  render() {
    const { historyPayment, collapse } = this.state;
    const { t, total, count } = this.props;
    return (
      <React.Fragment>
        <Snackbar
          color="white"
          onRef={snackbar => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={id => (this.loading = id)} />
        <TableFormat
          onRef={ref => (this.mTable = ref)}
          orderBy=""
          title={t("service_ownerspa_createservice_payment")}
          showFilter={false}
          placeholder={t("search")}
          headCells={headCells}
          totalCount={total}
          count={count}
          size={"medium"}
          isCollapse={true}
          collapse={collapse}
          renderCollapse={this.renderCollapse}
          handleOpenCollapes={this.handleOpenCollapes}
          getList={this.getHistory}
          showFilterBranch={false}
          hiddenSearch={true}
          showCheckBox={false}
          rows={historyPayment.map(row => {
            return {
              id: row._id,
              createdAt: this.changeFormat(row.createdAt),
              oldBalance: (
                <PriceFormat
                  value={`${row.oldBalance} ${this.props.currencyCode}`}
                />
              ),
              newBalance: (
                <PriceFormat
                  value={`${row.newBalance} ${this.props.currencyCode}`}
                />
              ),
              content: t("payment_" + row.content),
              creator:
                row.creator && row.creator.role && row.creator.name
                  ? t("payment_" + row.creator.role) + " " + row.creator.name
                  : ""
            };
          })}
        />
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  currencyCode: state.setting.setting
    ? state.setting.setting.currencyCode
    : "VND",
  adminService: state.service.adminService,
  total: state.auditBalance.total,
  count: state.auditBalance.count
});

const mapDispatch = dispatch => ({
  getHistory: dispatch.auditBalance.getHistory
});

export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(style, { withTheme: true })(Payment)));
